import { SaveWordsList } from "components/settings";
import { WidgetSettingFC } from "types/Setting";
import { ValidationLimitProps } from "util/widgeTransformData";

interface WordListData {}

interface WordListProps {
  settingName: string;
}

export const RandomNameWordList: WidgetSettingFC<WordListData, WordListProps> = (props) => {
  const { settings, updateAnyWidgetSetting, info } = props;

  const handleConvertData = (params: ValidationLimitProps) => params.value;

  return (
    <SaveWordsList
      settingName={info.settingName}
      updateSetting={updateAnyWidgetSetting!}
      value={settings.nameList}
      onConvertData={handleConvertData}
      isGroupMaker={true}
    />
  );
};
